import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en';
import nl from './locales/nl';

/**
 * i18n configuration for the Quotr frontend
 *
 * Supported languages:
 * - nl (Dutch) - default
 * - en (English)
 *
 * Language selection:
 * - Always starts in Dutch
 * - User can change language via LanguageSwitcher (when feature flag is enabled)
 * - Language preference is persisted in localStorage by LanguageSwitcher
 *
 * File organization:
 * - Translation files are split by screen/section to reduce merge conflicts
 * - At runtime, all translations are merged into a single 'translation' namespace
 * - This maintains backward compatibility with existing t() calls
 */
i18n.use(initReactI18next).init({
	resources: {
		nl,
		en
	},
	lng: 'nl', // Always start with Dutch
	fallbackLng: 'nl',
	supportedLngs: ['nl', 'en'],
	debug: import.meta.env.DEV,

	interpolation: {
		escapeValue: false // React already escapes values
	}
});

// Keep <html lang> in sync with the active UI language so it reflects what is
// actually rendered — Chrome only offers translation when the content language
// differs, and the attribute stays correct after the user switches via LanguageSwitcher.
const syncDocumentLang = (lng: string) => {
	document.documentElement.lang = lng;
};
i18n.on('languageChanged', syncDocumentLang);
syncDocumentLang(i18n.language);

export default i18n;
